import { render, staticRenderFns } from "./sales-order.vue?vue&type=template&id=77ce2550"
import script from "./sales-order.vue?vue&type=script&lang=ts"
export * from "./sales-order.vue?vue&type=script&lang=ts"
import style0 from "./sales-order.vue?vue&type=style&index=0&id=77ce2550&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports